import { CheckCircle, XCircle } from "lucide-react";
import silverFox from './../assets/images/Weddings/SilverFox/silverFox.webp'
import grayFox from './../assets/images/Weddings/GrayFox/grayFox.png'
import grandAfternoonTea from './../assets/images/Weddings/GrandAfternoonTea/grandAfternoonTea.png'
import fennecFox from './../assets/images/Weddings/FennecFox/fennecFox.png'

const packages = [
  {
    name: "The Silver Fox Package",
    logo: silverFox,
    inclusions: [
      "Dedicated Wedding Executive",
      "Arrival drinks or After ceremony drinks",
      "Master of Ceremonies",
      "White linen & glassware",
      "Cake stand & silver knife",
      "Chiavari chairs & sashes",
      "Overhead projector screen",
      "Children's menu",
      "Prosecco toast",
      "Evening buffet (hog roast or street food)",
      "Additional evening guest charge",
      "DJ",
      "Extended bar to 12:30 AM",
      "Overnight stay with breakfast",
      "3-Course Meal",
      "Wine with meal",
    ],
  },
  {
    name: "The Gray Fox Package",
    logo: grayFox,
    inclusions: [
      "Dedicated Wedding Executive",
      "Arrival drinks or After ceremony drinks",
      "Master of Ceremonies",
      "White linen & glassware",
      "Cake stand & silver knife",
      "Chiavari chairs & sashes",
      "Overhead projector screen",
      "Children's menu",
      "Prosecco toast",
      "Evening buffet (hog roast or street food)",
      "Additional evening guest charge",
      "DJ",
      "Extended bar to 12:30 AM",
      "Overnight stay with breakfast",
      "Plated BBQ buffet",
    ],
  },
  {
    name: "The Grand Afternoon Tea Package",
    logo: grandAfternoonTea,
    inclusions: [
      "Dedicated Wedding Executive",
      "Arrival drinks or After ceremony drinks",
      "Master of Ceremonies",
      "White linen & glassware",
      "Cake stand & silver knife",
      "Chiavari chairs & sashes",
      "Overhead projector screen",
      "Children's menu",
      "Prosecco toast",
      "Evening buffet (hog roast or street food)",
      "Additional evening guest charge",
      "DJ",
      "Extended bar to 12:30 AM",
      "Overnight stay with breakfast",
      "Silver Candelabras",
      "Finger sandwiches & sweet treats",
      "Assortment of teas",
      "Vintage-style crockery",
    ],
  },
  {
    name: "The Fennec Fox Package",
    logo: fennecFox,
    inclusions: [
      "Available for ceremonies after 3:30 PM",
      "Dedicated Wedding Executive",
      "Arrival drinks or After ceremony drinks",
      "Master of Ceremonies",
      "White linen & glassware",
      "Cake stand & silver knife",
      "Chiavari chairs & sashes",
      "Overhead projector screen",
      "Children's menu",
      "Prosecco toast",
      "Evening buffet (hog roast or street food)",
      "Additional evening guest charge",
      "DJ",
      "Extended bar to 12:30 AM",
      "Overnight stay with breakfast",
      "Canapés (choice of 4)",
    ],
  },
];

const allInclusions = [...new Set(packages.flatMap((pkg) => pkg.inclusions))];

const PackageComparison = () => {
  return (
    <div className="overflow-x-auto p-6">
      <h2 className="text-3xl font-semibold text-center mb-6">Compare Wedding Packages</h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300 text-sm md:text-base">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-4 text-left">Inclusions</th>
              {packages.map((pkg) => (
                <th key={pkg.name} className="border p-4 text-center">
                  <img src={pkg.logo} alt={pkg.name} className="h-8 md:h-10 mx-auto mb-2" />
                  {pkg.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {allInclusions.map((inclusion) => (
              <tr key={inclusion} className="odd:bg-gray-50 even:bg-white">
                <td className="border p-2 md:p-4">{inclusion}</td>
                {packages.map((pkg) => (
                  <td key={pkg.name} className="border p-2 md:p-4 text-center">
                    {pkg.inclusions.includes(inclusion) ? (
                      <CheckCircle className="text-green-500 w-4 h-4 md:w-5 md:h-5 mx-auto" />
                    ) : (
                      <XCircle className="text-red-500 w-4 h-4 md:w-5 md:h-5 mx-auto" />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PackageComparison;
